// extracted by mini-css-extract-plugin
export default {"chart":"main-chart_chart__8DS8M","arrowBtn":"main-chart_arrowBtn__M59YI","middle":"main-chart_middle__lq-L0","title":"main-chart_title__xMeK1"};